import {batch} from 'react-redux';
import {AutoCalibrationControllerState, SetTrayModalType} from 'constants/dataEnum';
import {setIsManualReteachPage, showLoading} from 'stores/actions/appStateAction';
import {setManualReteachCurrentPosition, setSelectedWellStyle} from 'stores/actions/reteachPlateAction';
import FormattedHTMLMessage from 'components/FormattedHTMLMessage';
import {InstrumentProcessType} from 'constants/instrumentStatusEnum';
import {selectSessionUserUsername} from 'stores/selectors/sessionSelectors';
import {
  getCurrentPosition,
  getStatusManualPlate,
  postManualReteachReturnTips,
  postManualReteachScanTips,
} from '../instrumentBusiness';
import {checkTrayReadiness} from '../trayCheckingBusiness';
import {onEnterCalibrationMenuErrorHandler} from '../menuBusiness';
import {manualReteachMissingTrayHandler} from '../errorHandlers/manualReteachErrorHandler';
import {showErrorMissingTrayModal} from '../modalStateBusinessAction';
import {saveState} from '../stateBusiness';
import {checkAndHandleIsAllowedToStartProcess} from '../instrumentStatusBusiness';

export const modalPreparationManualReteachPlateConfirmation =
  (username, labwareID, ID_DECK, colTipCount, rowTipCount, row, col, groupIndex, isIgnore = false) =>
  (dispatch) => {
    // call API to processing modal confirmation
    const response = dispatch(
      postManualReteachScanTips(username, labwareID, ID_DECK, colTipCount, rowTipCount, row, col, isIgnore, groupIndex),
    );

    return response;
  };

export const manualReteachPlateReturnTips = (username, isReturnToCaddy) => async (dispatch) => {
  // call API to processing return the tips
  const response = dispatch(postManualReteachReturnTips(username, isReturnToCaddy));

  return response;
};

export const checkOngoingManualReteachProcess = () => async (dispatch, getState) => {
  const username = selectSessionUserUsername(getState());
  const response = await dispatch(getStatusManualPlate());
  const {isPhase1Busy, isPhase2Busy, manualPlateDefinitionControllerState, usernameExecutor} = response;

  const isExecutor = username === usernameExecutor;
  const isIdle = manualPlateDefinitionControllerState === AutoCalibrationControllerState.IDLE;

  return {
    isExecutor,
    isIdle,
    calibrationStatus: manualPlateDefinitionControllerState,
    calibrationExecutor: usernameExecutor,
    isPhase1Busy,
    isPhase2Busy,
  };
};

export const checkAndLoadManualReteachProcess = () => async (dispatch, getState) => {
  const {reteachPlateState} = getState();
  const {currentInfo} = reteachPlateState.manualReteachPlate;
  const ongoingStatus = await dispatch(checkOngoingManualReteachProcess());
  const {isExecutor, calibrationStatus, isPhase1Busy, isPhase2Busy} = ongoingStatus;

  if (!isExecutor) {
    return ongoingStatus;
  }

  if (calibrationStatus === AutoCalibrationControllerState.RUNNING) {
    if (!isPhase1Busy) {
      const respPosition = await dispatch(getCurrentPosition());

      await dispatch(openManualReteachPage(respPosition));
      dispatch(saveState());
    } else {
      dispatch(
        showLoading(
          <FormattedHTMLMessage id="plateTypeEditorContainer.manualReteachPlate.modalPreparation.Confirm.loading" />,
        ),
      );
    }

    if (isPhase2Busy) {
      const returnInfo = currentInfo.returnToCaddy ? 'caddy' : 'waste bin';
      dispatch(
        showLoading(
          <FormattedHTMLMessage
            id="plateTypeEditorContainer.manualReteachPlate.returnTipsConfirmation.content.loading"
            values={{messageInfo: returnInfo}}
          />,
        ),
      );
    }
  } else if (calibrationStatus === AutoCalibrationControllerState.IDLE) {
    dispatch(setSelectedWellStyle({}));
  }

  return ongoingStatus;
};

export const handleManualReteachPreReq = () => async (dispatch) => {
  const isAllowed = await dispatch(checkAndHandleIsAllowedToStartProcess(InstrumentProcessType.MANUAL_RETEACH_PLATE));
  const {isTrayReady, isNoTrayAttached, errorCode: trayErrorCode} = await dispatch(checkTrayReadiness());

  if (!isAllowed) return false;

  if (isNoTrayAttached) {
    const callback = () => dispatch(manualReteachMissingTrayHandler());

    dispatch(showErrorMissingTrayModal(callback));
  } else if (!isTrayReady) {
    dispatch(onEnterCalibrationMenuErrorHandler(trayErrorCode, SetTrayModalType.PLATE_TYPE_EDITOR));
  }

  return isTrayReady;
};

export function openManualReteachPage(currentPosition) {
  return async (dispatch) => {
    const isReadyToProceed = await dispatch(handleManualReteachPreReq());

    if (!isReadyToProceed) return;

    batch(() => {
      dispatch(setManualReteachCurrentPosition(currentPosition));
      dispatch(setIsManualReteachPage());
    });
  };
}
